// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"604dfc16","732":"a5d350ec","977":"e9c78ccc"}[chunkId] + ".chunk.js");